/**
 * Shared by ZoneForm and ZoneEditorSkeleton so the page doesn't shift when the zone loads: a narrow
 * fields column beside a map that takes the rest of the width and most of the viewport height, stacked on phones.
 */
export const ZONE_EDITOR_GRID = 'grid gap-6 lg:grid-cols-[20rem_minmax(0,1fr)]';
export const ZONE_MAP_HEIGHT = 'h-[28rem] lg:h-[calc(100dvh-15rem)] lg:min-h-[30rem]';
